import { actionTypes } from '@/core/constants'

export default {
	methods: {
		fecharModalEnviarFornecedor() {
			this.emailFornecedor = ''
			this.exibirModalEnviarFornecedor = false
		},
		abrirModalEnviarFornecedorSemBusca({ idAssociacao, emailFornecedor }) {
			this.exibirModalEnviarFornecedor = true
			this.emailFornecedor = emailFornecedor
			this.idAssociacao = idAssociacao
		},
		async abrirModalEnviarFornecedorComBusca(idAssociacao) {
			const { email } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_EMAIL_FORNECEDOR,
				idAssociacao,
			)
			this.exibirModalEnviarFornecedor = true
			this.emailFornecedor = email
			this.idAssociacao = idAssociacao
		},
	},
}
